import { Injectable, NgZone } from '@angular/core';
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar'
import { HttpErrorResponse } from '@angular/common/http'

@Injectable({
  providedIn: 'root'
})
export class HelperService {

  constructor(private zone: NgZone, private _snackBar: MatSnackBar) { }

  public delay(ms: number) {
    return new Promise( resolve => setTimeout(resolve, ms) )
  }

  horizontalPosition: MatSnackBarHorizontalPosition = 'center'
  verticalPosition: MatSnackBarVerticalPosition = 'top'

  public openSnackBar(message: string, extratime: number, button?: string, error?: HttpErrorResponse) {
    this.zone.run(() => {
      this._snackBar.open(message, button, {
        horizontalPosition: this.horizontalPosition,
        verticalPosition: this.verticalPosition,
        duration: 4000 + extratime,
        panelClass: ['my-snackbar']
      })
    })
  }

  public clearLocalStorage() {
    localStorage.removeItem('currentUser')
  }

  isLoggedIn(): boolean {
    return !!localStorage.getItem('currentUser');
  }

  getCurrentUser(): any {
    const user = localStorage.getItem('currentUser');
    return user ? JSON.parse(atob(user)) : null;
  }
}
